module.exports = __webpack_public_path__ + "static/virego_main_5-14f06d5af497a5c4639dc305cd299e98.png";